module.exports = __webpack_public_path__ + "media/images/logo_4Talent-0f1fb480ec9632f4409230595873a81e.png";